export class Opcao {
    public id: number;
    public descricao: string;
    public valorResposta: number;
    public pergunta: number;
    public ativa: boolean;
    public nomeUnico: string;
    public tipoOpcao: number;

    public idQuestionario: number;
    public idTabelaSitab: number;
    public caminhoServico: string;

    public idRespostas: string[];


}
